export default __webpack_public_path__ + "static/media/Text_HighlighterBackground.ef3ac651.svg";